export default "__VITE_ASSET__41ZMKFZF__"